<template>
    <div class="fade_menu" :class="{ 'active': show }" @click="showMenu(false)"></div>
    <div class="open_menu p_top_header" :class="{ 'active': show }">
        <div class="d_table h_full">
            <div class="d_table_cell">
                <nav class="nav_menu">
                    <ul>
                        <li>
                            <a v-link="{ name: 'about' }">
                                {{ $t('the_guco') }}
                                <span><i class="fa fa-caret-right"></i> {{ $t('messages.menu_about_text') }}</span>
                            </a>
                        </li>
                        <li>
                            <a v-link="{ name: 'cases' }">
                                {{ $t('cases') }}
                                <span><i class="fa fa-caret-right"></i> {{ $t('messages.menu_cases_text') }}</span>
                            </a>
                        </li>
                        <li>
                            <a v-link="{ name: 'projects' }">
                                {{ $t('projects') }}
                                <span><i class="fa fa-caret-right"></i> {{ $t('messages.menu_projects_text') }}</span>
                            </a>
                        </li>
                        <li>
                            <a v-link="{ name: 'clients' }">
                                {{ $t('clients') }}
                                <span><i class="fa fa-caret-right"></i> {{ $t('messages.menu_clients_text') }}</span>
                            </a>
                        </li>
                        <li>
                            <a v-link="{ name: 'contact' }">
                                {{ $t('contact') }}
                                <span><i class="fa fa-caret-right"></i> {{ $t('messages.menu_contact_text') }}</span>
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="row t_sm_center m_t_20">
                    <div class="col-sm-6 col-md-5">
                        <p class="c_white"><i class="fa fa-fw fa-phone"></i> +55 (15) 3227-5410</p>
                        <p class="c_white"><i class="fa fa-fw fa-envelope-o"></i> contato@guco.com.br</p>
                    </div>
                    <div class="col-sm-6 col-md-5">
                        <aside class="social_links aside_menu">
                            <ul>
                                <li><a href="https://www.facebook.com/gucoweb/" target="_blank"><i class="fa fa-fw fa-facebook"></i></a></li>
                                <li><a href="https://twitter.com/guco_web" target="_blank"><i class="fa fa-fw fa-twitter"></i></a></li>
                                <li><a href="https://www.linkedin.com/company/2649725" target="_blank"><i class="fa fa-fw fa-linkedin"></i></a></li>
                                <li><a href="https://www.behance.net/guco" target="_blank"><i class="fa fa-fw fa-behance"></i></a></li>
                            </ul>
                        </aside>
                    </div>
                    <div class="col-sm-12 col-md-2 languages">
                        <a @click="changeLanguage('en-US')" :class="{ 'active': getLang == 'en-US' }">
                            EN
                        </a>
                        <a @click="changeLanguage('pt-BR')" :class="{ 'active': getLang == 'pt-BR' }">
                            PT
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { showMenu as show } from '../vuex/main-menu/getters'
    import { getLang } from '../vuex/settings/getters'
    import { showMenu } from '../vuex/main-menu/actions'
    import { changeLanguage } from '../vuex/settings/actions'

    import jQuery from 'jquery'

    export default {
        vuex: {
            getters: {
                show,
                getLang
            },
            actions: {
                showMenu,
                changeLanguage
            }
        }
    }
</script>



// WEBPACK FOOTER //
// GcMenu.vue?c3b06a98